export default __webpack_public_path__ + "static/media/resume.ce34c39f.pdf";